(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nc-planning-quote"]) return;
  try {
    
(()=>{
  const root=document.getElementById('nc-planning-quote');if(!root)return;
  const q=id=>root.querySelector('#ncq-'+id),form=root.querySelector('form'),message=q('message');
  const key=root.dataset.storageKey;let pending=null;
  try{pending=JSON.parse(sessionStorage.getItem(key)||'null');}catch(e){}
  const valid=pending&&typeof pending.csv==='string'&&typeof pending.summary==='string'&&typeof pending.path==='string'&&/^\/pages\/[a-z0-9-]+$/.test(pending.path)&&Date.now()-pending.time<86400000;
  if(!valid){message.textContent=message.dataset.missing;return;}
  q('back').href=pending.path;q('summary').textContent=pending.summary;q('review').hidden=false;
  if(q('success')){
    q('download').hidden=false;q('print').hidden=false;
    q('download').addEventListener('click',()=>{const url=URL.createObjectURL(new Blob(['\uFEFF'+pending.csv],{type:'text/csv;charset=utf-8'}));const a=document.createElement('a');a.href=url;a.download=(pending.filename||'natural-communities-plan.csv').replace(/[^a-zA-Z0-9._-]/g,'-');root.append(a);a.click();a.remove();setTimeout(()=>URL.revokeObjectURL(url),1000);});
    q('print').addEventListener('click',()=>{q('review').open=true;window.print();});
    return;
  }
  q('tool').textContent=pending.title;
  if(pending.location)q('location').value=pending.location;
  if(pending.timing)q('timing').value=pending.timing;
  if(pending.contact){q('email').value=pending.contact.email||q('email').value;q('name').value=pending.contact.name||q('name').value;q('location').value=pending.contact.location||q('location').value;q('timing').value=pending.contact.timing||q('timing').value;q('notes').value=pending.contact.notes||'';}
  const body='PLANNING TOOL QUOTE REQUEST\n\nThe visitor requested a download and a quote. This is not an order or a newsletter subscription.\n\nTool: '+pending.title+'\nSource: https://naturalcommunities.net'+pending.path+'\nPrepared: '+new Date(pending.time).toISOString()+'\n\nCALCULATED SPECIFICATION (CSV TEXT)\n'+pending.csv;
  if(body.length>200000){message.textContent=message.dataset.tooLarge;return;}
  q('body').value=body;q('submit').disabled=false;
  form.addEventListener('submit',event=>{if(!form.checkValidity())return;try{pending.contact={email:q('email').value,name:q('name').value,location:q('location').value,timing:q('timing').value,notes:q('notes').value};sessionStorage.setItem(key,JSON.stringify(pending));}catch(e){event.preventDefault();message.textContent=message.dataset.missing;return;}message.textContent=message.dataset.sending;});
})();

  } catch(e) { console.error(e); }
})();
})();
